import GlobalConfig from './config'
import { Base64 } from './base64'
import { JwtDecode } from './jwtdecode'
import IdentityService from '@/service/identity';
const identity = new IdentityService();

export class TokenHelper {
  static getAccessToken() {
    let val = window.localStorage.getItem(GlobalConfig.auth.accessTokenKey)
    if (val) {
      return val
    }
    return ''
  }

  static setAccessToken(token) {
    return window.localStorage.setItem(GlobalConfig.auth.accessTokenKey, token)
  }

  static removeAccessToken() {
    return window.localStorage.removeItem(GlobalConfig.auth.accessTokenKey)
  }

  static getProvider() {
    let value = window.localStorage.getItem(GlobalConfig.auth.externalProviderKey)
    let base64 = new Base64()
    return value ? JSON.parse(base64.decode(value)) : null
  }

  static setProvider(provider) {
    let base64 = new Base64()
    window.localStorage.setItem(GlobalConfig.auth.externalProviderKey, base64.encode(JSON.stringify(provider), false))
  }

  static removeProvider() {
    window.localStorage.removeItem(GlobalConfig.auth.externalProviderKey)
  }

  static parseUserToken(token) {
    let user = { authenticated: false, cultureName: null, displayName: null, email: null, name: null, username: null, roles: [], verified: false, enabled: false, userId: null, exp: null, timeZoneId: null }
    if (token) {
      let decodedToken = JwtDecode.decodeToken(token)
      if (!user.authenticated) {
        user.authenticated = true
      }
      user.displayName = decodedToken.email ? decodedToken.email : decodedToken.preferred_username
      user.email = decodedToken.email
      user.name = user.email
      if (typeof decodedToken.role === 'string') {
        user.roles = [decodedToken.role]
      } else {
        user.roles = decodedToken.role
      }
      user.verified = decodedToken.emial_verified
      user.exp = new Date(decodedToken.exp * 1000)
      user.userId = decodedToken.sub
    }
    return user
  }

  static getBearerToken() {
    let user = identity.getUser();
    let token = (user || "").access_token;
    let authValue = typeof token === 'undefined' ? null : 'Bearer ' + token
    return {
      Authorization: authValue
    }
  }

  static isTokenCurrent(value) {
    let user
    if (typeof value === 'string') {
      if (value === '') {
        return false
      }
      user = TokenHelper.parseUserToken(value)
    } else {
      user = value
    }

    if (!user) { return null } else { return user.exp && user.exp > new Date() }
  }
}




// WEBPACK FOOTER //
// ./src/common/token-helper.js